import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propShape, propStr, propChildren, propId, propNumber, } from '../../../../helpers/custom-prop-types';
import { slideSearchPageHelper } from '../../../../helpers/page/SlideSearch';
import { useBoolState } from '../../../../helpers/use/useHook';
import Hover from '../../../Ui/System/Hover';
import Tooltip from '../../../Ui/Tooltip/Tooltip';
const SlideSearchFilterListItemInner = (props) => {
    const { children, className, id, labelClassName, name, style, tooltipZIndex, } = props;
    const { boolState: isTooltipShowState, changeFalse: hideTooltip, changeTrue: showTooltip, } = useBoolState(false);
    const onMouseEnter = useCallback((e) => {
        const { offsetWidth, parentElement: { offsetWidth: parentOffsetWidth }, } = e.currentTarget;
        if (offsetWidth > parentOffsetWidth) {
            showTooltip();
        }
    }, [showTooltip]);
    return (_jsxs("li", Object.assign({ className: className, style: style }, { children: [children, _jsx(Hover, { children: _jsx("label", Object.assign({ className: labelClassName, htmlFor: `tags[${id}]` }, { children: _jsx(Tooltip, Object.assign({ className: 'category_item_button_text_box', html: _jsx("div", { children: name }), open: isTooltipShowState, zIndex: tooltipZIndex }, { children: _jsx("span", Object.assign({ className: 'category_item_button_text', onMouseEnter: onMouseEnter, onMouseLeave: hideTooltip }, { children: slideSearchPageHelper.filterButtonFormat(name) })) })) })) })] })));
};
SlideSearchFilterListItemInner.propTypes = {
    children: propChildren().isRequired,
    className: propStr().isRequired,
    id: propId().isRequired,
    labelClassName: propStr().isRequired,
    name: propStr().isRequired,
    style: propShape(),
    tooltipZIndex: propNumber(),
};
SlideSearchFilterListItemInner.defaultProps = {
    style: undefined,
    tooltipZIndex: undefined,
};
export default SlideSearchFilterListItemInner;
